import { Box, Text } from '@chakra-ui/react'
import { ModalBuild, SelectBuild } from 'components/molecules'
import { ModalBuildHandle } from 'components/molecules/ModalBuild/interfaces'
import { InstitutionsResponseDTO } from 'models'
import {
    forwardRef,
    ForwardRefRenderFunction,
    useImperativeHandle,
    useRef,
    useState
} from 'react'
import SendingFiles from '../SendingFiles'
import { listDocumentTypes } from './constants'

interface ModalAttachmentsProps {
    initial: InstitutionsResponseDTO
    onLoadAttachments: () => void
}

export interface RefModalAttachments {
    onOpenModal: () => void
}

const ModalAttachments: ForwardRefRenderFunction<
    RefModalAttachments,
    ModalAttachmentsProps
> = ({ initial, onLoadAttachments }, ref) => {
    const refModal = useRef<ModalBuildHandle>(null)
    const [typeDocumentSelected, setTypeDocumentSelected] = useState<number>()
    const onCancel = () => {
        refModal.current?.onClose()
    }

    const onOpenModal = () => {
        refModal.current?.onOpen()
    }

    useImperativeHandle(ref, () => ({
        onOpenModal
    }))

    const onLoadData = () => {
        onLoadAttachments()
    }

    const onChangeTypeDocument = (e: any) => {
        setTypeDocumentSelected(e.target.value)
    }

    return (
        <ModalBuild
            ref={refModal}
            closeOnOverlayClick={false}
            title=" "
            size="2xl"
            onCancel={onCancel}
        >
            <Box
                display="flex"
                textAlign="center"
                alignItems="center"
                justifyContent="center"
                flexDirection="row"
                zIndex={12}
                pt="25px"
            >
                <Text
                    fontSize="xl"
                    whiteSpace="pre"
                    color="black"
                    fontWeight="700"
                >
                    Anexos
                </Text>
            </Box>

            <Box
                display="flex"
                flexDirection="column"
                zIndex={12}
                pt="32px"
                px="32px"
                width="380px"
            >
                <Text
                    fontSize="medium"
                    whiteSpace="pre"
                    color="black"
                    fontWeight="700"
                >
                    Selecionar Tipo de Documento:
                </Text>

                <SelectBuild
                    id="tipoDocumento"
                    options={[...listDocumentTypes]}
                    onChange={onChangeTypeDocument}
                />
            </Box>

            <SendingFiles
                onClose={onCancel}
                onSubmit={onLoadData}
                id={initial.id}
                typeDocument={typeDocumentSelected as number}
            />
        </ModalBuild>
    )
}

export default forwardRef(ModalAttachments)
